module.exports = __webpack_public_path__ + "img/SKMJ_protect5.b1cf3b80.png";